export enum InventoryItemState {
  INVENTORY_ITEM_EXISTS = 'ITEM_EXISTS',
  INVENTORY_ITEM_DOES_NOT_EXIST = 'ITEM_DOES_NOT_EXIST',
  INVENTORY_ITEM_IS_NOT_VALID = 'ITEM_IS_NOT_VALID',
  INVENTORY_ITEM_REVIEW = 'ITEM_REVIEW',
  INVENTORY_ITEM_STOLEN = 'ITEM_STOLEN',
  INVENTORY_ITEM_SOLD = 'ITEM_SOLD'
}
